module.exports = __webpack_public_path__ + "media/images/admin2/AdminForm__value__cover-colours__choices__a--active-00f3f3b74bd6513f5ec43b57b880eb36.svg";